<script>
  import { onMount } from "svelte";
  import { localeOrderBy, slice, loadPersisted, savePersisted } from "../../mjnUtils";
  import Pagination from "./pagination/Pagination.svelte";

  let { http, toastr, search } = $props();

  let slackMembers = $state([]);
  let searchText = $state("");
  let sortType = $state(loadPersisted("slack", "sortType", "name"));
  let sortReverse = $state(loadPersisted("slack", "sortReverse", false));
  let currentPage = $state(1);
  const itemsPerPage = 20;

  $effect(() => {
    savePersisted("slack", "sortType", sortType);
    savePersisted("slack", "sortReverse", sortReverse);
  });

  onMount(() => {
    http.get("/api/slack.php").then(
      (response) => {
        slackMembers = response.data.slackMembers.map((m) =>
          Object.assign({}, m, {
            pairingSort:
              m.id && m.id !== "guest" && m.id !== "special"
                ? m.deactivated
                  ? -m.id
                  : m.id
                : m.id,
          }),
        );
      },
      () => {
        toastr.error("Błąd połączenia");
      },
    );
  });

  let filteredSlackMembers = $derived(search(slackMembers, searchText));
  let sortedSlackMembers = $derived(localeOrderBy(filteredSlackMembers, sortType, sortReverse));
  let totalItems = $derived(filteredSlackMembers.length);
  let numPages = $derived(Math.max(1, Math.ceil(totalItems / itemsPerPage)));
  let pagedSlackMembers = $derived(slice(sortedSlackMembers, itemsPerPage, currentPage));

  $effect(() => {
    searchText;
    currentPage = 1;
  });

  function setSort(field) {
    if (sortType === field) {
      sortReverse = !sortReverse;
    } else {
      sortType = field;
      sortReverse = false;
    }
  }
</script>

<h3><i class="fab fa-slack fa-lg"></i>&nbsp;&nbsp;Slack</h3>
<div class="clearfix"></div>
<div class="text-left"><small><i class="fa fa-random" aria-hidden="true"></i>
W tej chwili mamy {slackMembers.length} członków Slacka, {filteredSlackMembers.length} przefiltrowanych poniżej.
</small><p></p></div>

<form>
    <div class="form-group">
      <div class="input-group">
        <div class="input-group-addon"><i class="fas fa-search"></i></div>
        <input type="text" class="form-control input-sm" placeholder="Wyszukaj użytkownika" bind:value={searchText}>
      </div>
    </div>
</form>

<table class="table table-condensed table-hover table-striped">
    <thead class="thead-default">
      <tr>
        <th>
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("name"); }}>
          Imię i nazwisko
          {#if sortType == "name" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "name" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th>
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("email"); }}>
          Email
          {#if sortType == "email" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "email" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th>
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("id"); }}>
            Sparowanie
            {#if sortType == "id" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
            {#if sortType == "id" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
      </tr>
    </thead>

    <tbody>
      {#each pagedSlackMembers as slackMember (slackMember.email)}
      <tr>
        <td>
        <img src={slackMember.avatarId} height="32" width="32"/>&nbsp;
        {slackMember.name}
        </td>
        <td>
        {slackMember.email}
        </td>
        <td>
          {#if slackMember.id === "guest"}
          <p>Gość</p>
          {:else if slackMember.id === "special"}
          <p>Konto specjalne</p>
          {:else if slackMember.id}
          <a href={"/member-detail/" + slackMember.id}>Tak{#if slackMember.deactivated} (były członek!){/if}</a>
          {:else}
          <p>Nie</p>
          {/if}
        </td>
      </tr>
      {/each}
    </tbody>

</table>

<Pagination {currentPage} {numPages} onPageChange={(page) => currentPage = page}/>
